import { render, staticRenderFns } from "./tagmodels.vue?vue&type=template&id=7da936cb&scoped=true"
import script from "./tagmodels.vue?vue&type=script&lang=js"
export * from "./tagmodels.vue?vue&type=script&lang=js"
import style0 from "./tagmodels.vue?vue&type=style&index=0&id=7da936cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da936cb",
  null
  
)

export default component.exports